import React from "react";

import { CONTENT } from "consts";
import {
  epocToDate,
  arrayToString,
  padZero,
  convertSecsToWords,
  decodeHandler,
  objectToArray,
  formatTime12hr,
  formatMonths,
  formatDates
} from "utils";
import { ReactComponent as LogsSettings } from "assets/images/app_svg/logs_settings.svg";

function SettingsLogs(props) {
  function Title() {
    switch (props.data.mode) {
      case "computerName":
        return computerNameLog(props.data);
      case "scheduleInfo":
        return scheduleInfoLog(props.data);
      case "email":
        return emailLog(props.data);
      case "advance":
        return advanceLog();
      case "source":
        return sourceLog(props.data);
      case "new":
        return newConfigureLog();
      case "backupPlan":
        return backupPlanLog(props.data);
      default:
        return null;
    }
  }

  function newConfigureLog() {
    return (
      <div className="logs_item_title">
        <LogsSettings />
        <p>{props.data.params}</p>
      </div>
    );
  }

  function advanceLog() {
    return (
      <div className="logs_item_title">
        <LogsSettings />
        <p>{CONTENT.appLogs.backupSettings.advanced + props.data.params}</p>
      </div>
    );
  }

  function sourceLog(data) {
    const sourceType =
      data.params.sourceType.list[data.params.sourceType.current].name;

    return (
      <div className="logs_item_title">
        <LogsSettings />
        <p>
          {CONTENT.appLogs.backupSettings.source +
            sourceType +
            (data.params.sourceType.current === "customize"
              ? "(" + arrayToString(data.params.volumes) + ")"
              : "")}
        </p>
      </div>
    );
  }

  function emailLog(data) {
    if (data.params?.addedEmails && data.params?.removedEmails) {
      if (
        data.params.addedEmails.length > 0 &&
        data.params.removedEmails.length > 0
      ) {
        return (
          <div className="logs_item_title">
            <LogsSettings />
            <p>{CONTENT.appLogs.backupSettings.emailMultiple}</p>
          </div>
        );
      }
      if (data.params.addedEmails.length > 0) {
        return (
          <div className="logs_item_title">
            <LogsSettings />
            <p>
              {CONTENT.appLogs.backupSettings.email +
                " New email" +
                (data.params.addedEmails.length > 1 ? "s are " : " is ") +
                CONTENT.appLogs.backupSettings.emailAdded}
            </p>
          </div>
        );
      } else if (data.params.removedEmails.length > 0) {
        return (
          <div className="logs_item_title">
            <LogsSettings />
            <p>
              {CONTENT.appLogs.backupSettings.email +
                " Email" +
                (data.params.removedEmails.length > 1 ? "s were " : " was ") +
                CONTENT.appLogs.backupSettings.emailRemoved}
            </p>
          </div>
        );
      } else return null;
    } else if (data.params?.smtp) {
      return (
        <div className="logs_item_title">
          <LogsSettings />
          <p>{CONTENT.appLogs.backupSettings.smtp}</p>
        </div>
      );
    } else if (
      data.params?.notifyOnFailure !== undefined &&
      data.params?.notifyOnSuccess !== undefined
    ) {
      return (
        <div className="logs_item_title">
          <LogsSettings />
          <p>{CONTENT.appLogs.backupSettings.enableDisableNotification}</p>
        </div>
      );
    } else if (data.params?.notifyOnDesktop !== undefined) {
      return (
        <div className="logs_item_title">
          <LogsSettings />
          <p>{CONTENT.appLogs.backupSettings.emailNotification}</p>
        </div>
      );
    }
    // else{
    //   return (
    //     <div className="logs_item_title">
    //       <LogsSettings />
    //       <p>{CONTENT.appLogs.backupSettings.smtp}</p>
    //     </div>
    //   );
    // }
  }

  function scheduleInfoLog(data) {
    switch (data.params.type) {
      case props.enums.ScheduleType.INTERVAL:
      case props.enums.ScheduleType.DAILY:
      case props.enums.ScheduleType.CUSTOM:
      case props.enums.ScheduleType.MONTHLY:
      case props.enums.ScheduleType.NO_SCHEDULE:
        return (
          <div className="logs_item_title">
            <LogsSettings />
            <p>
              {CONTENT.appLogs.backupSettings.schedule +
                displayBackupSchedule(data.params)}
            </p>
          </div>
        );
      case "multiple":
        return (
          <div className="logs_item_title">
            <LogsSettings />
            <p>
              {CONTENT.appLogs.backupSettings.schedule +
                CONTENT.appLogs.backupSettings.scheduleMultiple}
            </p>
          </div>
        );
      case "advance":
        return (
          <div className="logs_item_title">
            <LogsSettings />
            <p>
              {CONTENT.appLogs.backupSettings.schedule +
                CONTENT.appLogs.backupSettings.scheduleAdvanced}
            </p>
          </div>
        );
      case "cutOffTime":
        return (
          <div className="logs_item_title">
            <LogsSettings />
            <p>
              {CONTENT.appLogs.backupSettings.schedule +
                CONTENT.appLogs.backupSettings.cutOffTime}
            </p>
          </div>
        );
      default:
        return null;
    }
  }

  function displayBackupSchedule(scheduleInfo) {
    let timeObj12hr = formatTime12hr(scheduleInfo.startTime);
    let time12hr =
      timeObj12hr.hrs + ":" + timeObj12hr.min + " " + timeObj12hr.meridian;

    switch (props.enums.ScheduleType.props[scheduleInfo.type].key) {
      case "INTERVAL":
        return "Every " + convertSecsToWords(scheduleInfo.interval.selected);
      case "DAILY":
        return "Everyday at " + time12hr;
      case "CUSTOM":
        const weekDays = [];
        objectToArray(props.enums.WeekDays.props, { 1: "priority" }).forEach(
          val => {
            if (scheduleInfo.weekDays.includes(val.code)) {
              weekDays.push(props.enums.WeekDays.props[val.code]);
            }
          }
        );
        return "Every " + arrayToString(weekDays, "name") + " at " + time12hr;
      case "NO_SCHEDULE":
        return "Never";
      case "MONTHLY":
        return "Every selected month and day at " + time12hr;
      // return (
      //   "Every " +
      //   formatMonths(scheduleInfo.months, props.enums.Months) +
      //   " on " +
      //   formatDates(scheduleInfo.monthDays) +
      //   " at " +
      //   time
      // );
      default:
        break;
    }
  }

  function computerNameLog(data) {
    return (
      <div className="logs_item_title">
        <LogsSettings />
        <p>
          {CONTENT.appLogs.backupSettings.computerName +
            decodeHandler(data.params.name)}
        </p>
      </div>
    );
  }

  function Details() {
    return (
      <div className="logs_item_details">
        {epocToDate(props.timeStamp, "MMM d yyyy, hh:mm:ss")}
      </div>
    );
  }

  function planNameDecode(planName) {
    try {
      return decodeHandler(planName);
    } catch (e) {
      return planName;
    }
  }

  function backupPlanLog(plan) {
    let content = "";
    switch (plan.params.action) {
      case "editSettings":
        if (plan.params.type === "added") {
          content = (
            <p>
              {CONTENT.appLogs.backupPlan.added +
                planNameDecode(plan.params.planName)}
            </p>
          );
          break;
        } else if (plan.params.type === "removed") {
          content = (
            <p>
              {CONTENT.appLogs.backupPlan.removed +
                planNameDecode(plan.params.planName)}
            </p>
          );
          break;
        } else
          content = (
            <p>
              {CONTENT.appLogs.backupPlan.settingsChanged +
                planNameDecode(plan.params.planName)}
            </p>
          );
        break;
      case "enabled":
        content = (
          <p>
            {CONTENT.appLogs.backupPlan.enabled +
              planNameDecode(plan.params.planName)}
          </p>
        );
        break;
      case "disabled":
        content = (
          <p>
            {CONTENT.appLogs.backupPlan.disabled +
              planNameDecode(plan.params.planName)}
          </p>
        );
        break;
      case "deleted":
        content = (
          <p>
            {CONTENT.appLogs.backupPlan.deleted +
              planNameDecode(plan.params.planName) +
              " is deleted"}
          </p>
        );
        break;
      default:
        break;
    }
    return (
      <div className="logs_item_title">
        <LogsSettings />
        {content}
      </div>
    );
  }

  if (
    props.data.mode === "email" &&
    props.data.params.addedEmails &&
    props.data.params.removedEmails &&
    props.data.params.addedEmails.length === 0 &&
    props.data.params.removedEmails.length === 0
  ) {
    return null;
  } else {
    return (
      <div className="logs_item logs_new">
        <Title />

        <Details />
      </div>
    );
  }
}

export default SettingsLogs;
